import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { LLTextInputElement } from '../../types';

interface Props {
  element: LLTextInputElement;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const TWEET_HOST_HINT = 'Paste a link to your post on x.com or twitter.com.';

export function TextInputElement({ element, value, onChange, disabled }: Props) {
  const id = `ll-textinput-${element.index}`;
  const isTweet = element.inputType === 'tweet';

  return (
    <div className="space-y-1.5">
      <Label htmlFor={id} className="text-sm font-medium">
        {element.label}
      </Label>
      {element.urlInput && (
        <a
          href={element.urlInput}
          target="_blank"
          rel="noopener noreferrer"
          className="block text-xs text-primary underline underline-offset-2 hover:no-underline"
        >
          Source
        </a>
      )}
      <Input
        id={id}
        type={isTweet ? 'url' : 'text'}
        value={value}
        placeholder={element.placeholder}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        autoComplete="off"
      />
      {isTweet && <p className="text-xs text-muted-foreground">{TWEET_HOST_HINT}</p>}
    </div>
  );
}
